import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirector/Search",
    params
  );
};

const getById = (id) => {
  const params = {
    id,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirector/GetById",
    params
  );
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirector/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateItemActive = (id, isActive) => {
  const params = {
    id,
    isActive,
    userId: userData.userId(),
  };

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirector/UpdateActive",
    params
  );
};

const deleteItem = (id) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirector/Delete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

const swapOrder = (id1, id2) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirector/SwapOrder?userId=" +
      userData.userId() +
      "&id1=" +
      id1 +
      "&id2=" +
      id2
  );
};

const officerList = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirector/GetOfficerList"
  );
};

const officer = (id) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirector/GetOfficer?userId=" +
      id
  );
};

export {
  search,
  getById,
  updateItem,
  updateItemActive,
  deleteItem,
  swapOrder,
  officerList,
  officer,
};
